import { AFFILIATE_FIELDS } from "../../../@dhn/shared/queries/affiliate";
import { gql } from "apollo-boost";

//#region Resolvers menu de Autorizaciones

export const GET_AFFILIATE_DHN = gql`
  query Affiliate($where: AffiliateWhereUniqueInput) {
    affiliate(where: $where) {
      id
      firstName
      middleName
      lastName
      lastName2
      identificationCard
      dateOfBirth
    }
  }
`;

export const GET_PERSON_REGISTRY = gql`
  query PersonRegistry($where: AffiliateWhereInput) {
    getPersonRegistry(where: $where) {
      id
      name
      lastName
      lastName2
      identificationCard
      dateOfBirth
    }
  }
`;

export const SAVE_PERSON_REGISTRY = gql`
  mutation SavePersonRegistry($data: PersonRegistryInput) {
    resp: savePersonRegistry(data: $data) {
      isOk
      messages
    }
  }
`;

export const VALIDATE_AFFILIATE_UNIVERSAL = gql`
  query validateCoberturaUniversal($where: getAffiliateWhereInput) {
    item: validateCoberturaUniversal(where: $where) {
      ...AffiliateConsultFields
    }
  }
  ${AFFILIATE_FIELDS}
`;

export const GET_MEDICAL_STAFF = gql`
  query getMedicalStaff($where: MedicalStaffWhereInput) {
    items: getMedical(where: $where) {
      id
      fullname
      codigo
    }
  }
`;

export const GET_MEDICINES = gql`
  query getMedicines($where: MedicineWhereInput) {
    items: getMedicines(where: $where) {
      id
      name
      isDetailing
      nameDetailing
      price
      retailPrice
      codes
      rdfCode
      insuranceCode
      isChecked
      isCooled
      isGeneric
      lineId
      brandId
      contentCant
      ContentDetail
      brandName
      shapeName
      concentracionName

      moleculeMedicines {
        id
        moleculeId
        concentrationId
        concentrationUnitId
        molecule {
          id
          name
        }
        concentration {
          id
          name
        }

        concentrationUnit {
          id
          name
        }
      }
    }
  }
`;

export const START_PROCESS_AUTHORIZATION = gql`
  mutation procAuthorization($data: dataProcAuthorizationInput) {
    resp: procAuthorization(data: $data) {
      fullname
      noContract
      claimdate
      branchid
      branchname
      branchcode
      claimnumber
      prescriptiondate
      retireeid
      retireetelnumber
      doctorid
      doctorname
      claimId
      codAuthorizationMonumental

      claimvalue {
        name
        value
      }

      claim_payment {
        name
        value
      }

      claimcopay {
        name
        value
      }

      sumaryProcessed {
        claimvalue
        claim_payment
        claimcopay
      }

      arsid
      arsname
      userId
      userName
      statusid
      referralid
      medicineProcessed {
        medicineId
        # code
        room
        amount
        amountDetails
        concessionValue
        exceptionValue
        description
        simon
        commercialCode
        price
        priceDetails
        Pbs
        Pre
        # coverageIdRdf
      }
      medicineRejected {
        medicineId
        # code
        room
        amount
        amountDetails
        concessionValue
        exceptionValue
        description
        simon
        commercialCode
        price
        priceDetails
        Pbs
        Pre
        # coverageIdRdf
      }
    }
  }
`;

export const MEDICINES_VALIDATION = gql`
  query medicinesValidation($where: medicineValidationInput) {
    resp: medicineValidation(where: $where) {
      errorOccurred
      errorCode
      errorMessage
      observation
      requierePreautorizacion
    }
  }
`;

export const GET_CANCELATION_REASONS = gql`
  query GetCancelationReasons($filters: FiltersExpression) {
    reasons: getCancelationReasons(filters: $filters) {
      id
      description
    }
  }
`;

export const CANCEL_AUTHORIZATION = gql`
  mutation cancAuthorization($data: dataCancAuthorizationInput) {
    resp: cancAuthorization(data: $data) {
      claimnumber
      claimvalue
      claimPayment
      claimcopay
      message
      ErrorNumber
      ErrorMessage
    }
  }
`;

export const GET_DAYS_CONTINUOUS_PRESCRIPTIONS = gql`
  query getDaysContinuousPrescription($where: ClaimWhereInput) {
    item: getDaysContinuousPrescription(where: $where) {
      arsId
      days
    }
  }
`;

export const GET_BRANCH_OFFICES_FOR_USER_CALL_CENTER = gql`
  query getBranchUserCallCenter {
    branchesItems: getBranchUserCallCenter {
      id
      name
      pharmacyProviderId
    }
  }
`;

//#endregion

//#region Resolvers menu de Ultimas Autorizaciones

export const GET_BRANCH_ARS = gql`
  query getBranchArs {
    arses: getBranchArs {
      arsId
      branch
      arsName
      code_pss
      sendAudit
      isSdssArs
      branchOfficeId
      pharmacyProviderNIF
      addressBranchOffice
      phoneBranchOffice
      contactBranchOffice
    }
  }
`;

export const GET_BRANCH_PROVIDERS = gql`
  query getBranchProviders {
    providers: getBranchProviders {
      branchId
      branchName
      providerId
      providerName
      nif
    }
  }
`;

export const GET_CLAIM_HISTORY = gql`
  query getClaimHistorys($where: claimHistoryInput) {
    items: getClaimHistorys(where: $where) {
      claimId
      afiliate
      claimDate
      claimNumber
      interactionId
      userId
      userName
      reclaimed
      authorized
      difference
      sesionId
    }
  }
`;

export const GET_CLAIM = gql`
  query getClaim($where: ClaimWhereInput) {
    claim: getClaim(where: $where) {
      fullname
      claimId
      noContract
      claimdate
      branchid
      branchname
      branchcode
      claimnumber
      prescriptiondate
      retireeid
      retireetelnumber
      doctorid
      doctorname
      interactionid
      codAuthorizationMonumental
      prescriptionId

      claimvalue {
        name
        value
      }

      claim_payment {
        name
        value
      }

      claimcopay {
        name
        value
      }

      sumaryProcessed {
        claimvalue
        claim_payment
        claimcopay
      }

      arsid
      arsname
      userId
      userName
      statusid
      referralid

      medicineProcessed {
        medicineId
        amount
        amountDetails
        description
        price
        priceDetails
      }

      medicineRejected {
        medicineId
        amount
        amountDetails
        description
        price
        priceDetails
      }

      claimMedicines {
        medicineId
        amount
        amountDetails
        name: description
        price
        priceDetails
        code
      }
    }
  }
`;
//#endregion

//#region Resolvers menu Envío a Auditoria

export const GET_CLAIM_BY_AUDIT = gql`
  query getClaimByAudit($where: getByAudit) {
    items: getClaimByAudit(where: $where) {
      claimDate
      claimNumber
      claimValue
      claimPayment
      claimCopay
      statusName
      claimId
      arsId
    }
  }
`;

export const GET_TYPE_TAX_VOUCHER = gql`
  query getTypeTaxVoucher($where: ClaimWhereInput) {
    item: getTypeNCFByArsAudit(where: $where) {
      id
      name
      prefix
    }
  }
`;

export const SAVE_AUDIT = gql`
  mutation procSaveAudit($data: AuditWhereInput) {
    resp: procSaveAudit(data: $data) {
      razonSocial
      sucursal
      codigoFarmacia
      auditDate
      authorizationId
      authorizationNumber
      dateAuthorization
      rnc
      ncf
      amount
      amountPaymentByArs
      porcientoDescuento
      amountDescuento
      pharmacyId
      info
      user
      senasaBillingAudit
    }
  }
`;

export const GET_LIST_NCF = gql`
  query ListNcf($where: dataUserPharmacy) {
    ncfs: getListNCFs(where: $where) {
      ncf
    }
  }
`;

export const GET_CLAIM_BY_AUDIT_NCF = gql`
  query getClaimByAuditAndNCF($where: getByAudit) {
    items: getClaimByAuditAndNCF(where: $where) {
      claimDate
      claimNumber
      claimValue
      claimPayment
      claimCopay
      statusName
      claimId
      rnc
      senasaBillingAudit
    }
  }
`;

export const GET_REPORT_INFO_BY_AUDIT = gql`
  query getReportInfoByAudit($where: AuditWhereInput) {
    report: getReportInfoByAudit(where: $where) {
      razonSocial
      sucursal
      codigoFarmacia
      auditDate
      authorizationId
      authorizationNumber
      dateAuthorization
      rnc
      ncf
      amount
      amountPaymentByArs
      porcientoDescuento
      amountDescuento
      pharmacyId
      info
      user
      senasaBillingAudit
    }
  }
`;

//#endregion

//#region Resolvers menu Receta Electronica

export const GET_DIGITAL_PRESCRIPTION = gql`
  query getDigitalPrescription($where: arsMedicalInput) {
    super: getDigitalPrescription(where: $where) {
      prescriptionNumber
      patientId
      date #Fecha de Receta
      expiryDate
      arsId
      arsName #ARS
      digitalId
      statusId
      codeProgram
      recipeType #Tipo de receta
      doctorName #Medico
      doctorId
      planId

      infoProvider {
        branchId
        branchName
        providerId
        providerName
        codePSS
        discountPP
      }

      afiliate {
        noAffiliate
        fullname #Afiliado
        affiliateCardNumber
        Nss
        affiliateContrat
        birthDate
        status
        statusDesc
        phone
        ErrorNumber
        ErrorMessage
        gender
        Age
        planType
        affiliateId
        Token
        interactionid
        seccionNumber
        medicinePlan
        pypProgram

        medicinePlanList {
          IdPlan
          NombrePlan
          IdTipoPlan
          TipoPlan
          MontoTope
          Disponible
          FechaRenovacion
        }

        programPyPList {
          CodigoPrograma
          Programa
          CodigoCirculo
          Circulo
        }
      }

      digitalPrecriptiondetail {
        name #Medicamento
        quantity #Cantidad
        frecuency #Frecuencia
        frecuencyDaysHours #Frecuencia
        duration #Duracion
        durationDaysWeeksMonths #Duracion
        totalDosis #Total
        dispatchedDosis
        statusId
        doctorNote
        code
        id
        medicineId
      }
    }
  }
`;

export const GET_MEDICINE_DIGITAL_PRESCRIPTION = gql`
  query getMedicineDigitalPrescription($where: arsMedicalInput) {
    medicines: getMedicineDigitalPrescription(where: $where) {
      nameMolecula
      codeMolecula
      id
      price
      priceDetial
      nameMedicine
      nameMedicineDetail
      isDetailing
      content,
      isSpecial
    }
  }
`;

//#endregion

export const GET_RECIPE_TYPE = gql`
  query getRecipeTypes {
    recipeTypes {
      id
      name
      enabled
    }
  }
`;

export const GET_RECIPE_VALIDITY = gql`
  query recipeValidity($where: RecipeValidityInput) {
    recipeValidity(where: $where) {
      id
      validity
      arsId
      recipeId
    }
  }
`;

export const DATA_OFFERS = gql`
  query offers($where: offersInput, $relations: [String]) {
    offers(where: $where, relations: $relations) {
      id
      nameOffer
      arsId
      fromDate
      toDate
      percentDiscount
      enabled
      claimsOffersProcess {
        id
        lineId
        branchId
        branchOffice {
          id
          name
        }
        medicine {
          id
          name
        }
        arsEntity {
          id
          name
        }
        line {
          id
          name
        }
        saleValue
        coverageValue
        discountAmount
        discountPercentageOffer
        claimDate
        updateAt
      }
    }
  }
`;

export const GET_DATA_CLAIMS_OFFERS = gql`
  query offersClaimsProcess($where: offerClaimInput) {
    offersClaimsProcess(where: $where) {
      saleValue
      coverageValue
      discountAmount
      discountPercentageOffer
      claimDate
      lineName
      pharmacyName
      arsName
      medicineName
      pharmacyProviderName
    }
  }
`;

export const GET_OPTIONS = gql`
  query options($where: OptionWhereInput) {
    options(where: $where) {
      id
      name
      value
      type
    }
  }
`;

export const GET_DATA_REPORT_PARTIAL_DISPATCH = gql`
  query getDataReportPartialDispatch($where: partialReportI) {
    reportPartialDispatch(where: $where) {
      dataPatient {
        nameFullAffiliate
        NSS
        identificationCard
      }
      dataBranch {
        branchOfficeName
        branchOfficePhone
        codigoPSS
        pharmacyProviderNIF
      }
    }
  }
`;
